import { Link } from "react-router-dom";
import { ARTICLES } from "../../data/articles";
import { Reveal } from "../Reveal";

export const JournalTeaser = () => (
  <section className="bg-white py-24 md:py-32" data-testid="journal-teaser">
    <div className="mx-auto max-w-[1400px] px-4 md:px-8">
      <Reveal className="mb-14 grid gap-10 border-b border-neutral-950 pb-12 lg:grid-cols-[1fr_1.2fr] lg:items-end">
        <div>
          <p className="kicker">From the Journal</p>
          <h2 className="font-vogue mt-3 text-5xl leading-none text-neutral-950 md:text-6xl">The Edit</h2>
        </div>
        <p className="text-sm font-light leading-relaxed text-neutral-600 md:text-base">
          Lux Veritae is a Scottsdale medical spa for advanced skin correction — CO₂ and Erbium laser resurfacing, Xerf skin tightening, the Cosmelan® chemical peel, RF microneedling, injectables, permanent makeup, body contouring and medical weight loss. Our Journal shares the thinking behind every treatment.
        </p>
      </Reveal>
      <div className="grid gap-12 md:grid-cols-3">
        {ARTICLES.slice(0, 3).map((a) => (
          <Reveal key={a.slug}>
            <Link to={`/blog/${a.slug}`} className="group block" data-testid={`teaser-${a.slug}`}>
              <div className="aspect-[4/5] overflow-hidden bg-neutral-100"><img src={a.image} alt={a.title} className="img-zoom h-full w-full object-cover" loading="lazy" /></div>
              <p className="mt-5 text-[10px] font-semibold uppercase tracking-[0.35em] text-neutral-950">{a.category}</p>
              <h3 className="font-vogue mt-2 text-2xl leading-tight text-neutral-950 group-hover:text-neutral-500">{a.title}</h3>
            </Link>
          </Reveal>
        ))}
      </div>
      <div className="mt-14 text-center"><Link to="/blog" className="link-under" data-testid="teaser-all-link">Read the Journal</Link></div>
    </div>
  </section>
);
